import { api } from './NetworkUtility';
import { logError } from './ErrorService';

let getExpiringPaymentsAbortController = new AbortController();

/*
    This method will retrieve expiring payment data.
*/
export const getExpiringPayments = async (callbackHandler, callbackErrorHandler, companyNumber, paymentTypeCode) => {
    if (companyNumber == null || typeof companyNumber === 'undefined') {
        return;
    }
    
    const url = `/companies/${companyNumber}/payments/paymentTypes/${paymentTypeCode}/expiring`;
    
    getExpiringPaymentsAbortController.abort();
    getExpiringPaymentsAbortController = new AbortController();

    return api.get(url, {
        signal: getExpiringPaymentsAbortController.signal
    })
        .then((response) =>
            callbackHandler(response.data)
        )
        .catch(function (error) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?ep";
                });
            } else {
                callbackErrorHandler(error);
            }
        });
}